module.exports = __webpack_public_path__ + "font/f8b1df51ba843179fa1cc9b53d58127a.woff2";